export default __webpack_public_path__ + "static/media/jci.0e8a39be.png";